import { Skeleton, useTheme } from '@mui/material'
import { useSponsorOrganizationContent } from '../../queries'

interface BrandLogoProps {
  altText?: string
  sponsorOrgId?: string
  logoStyle?: any
  size?: 'small' | 'large'
  variant?: 'square' | 'default'
}

const LOGO_FIELD = {
  default: {
    dark: 'logoDarkLarge',
    light: 'logoLightLarge',
  },
  square: {
    dark: 'logoDarkSquare',
    light: 'logoLightSquare',
  },
} as const

// eslint-disable-next-line complexity
export const BrandLogo = ({
  altText,
  sponsorOrgId,
  logoStyle,
  size,
  variant = 'default',
}: BrandLogoProps) => {
  const theme = useTheme()

  const width =
    !size && !!logoStyle?.width && typeof logoStyle.width === 'number'
      ? logoStyle.width
      : size === 'small'
      ? 60
      : 100
  const height =
    !!logoStyle?.height && typeof logoStyle.height === 'number' ? logoStyle.height : undefined

  const { isPending, isError, isFetching, data } = useSponsorOrganizationContent({
    orgId: sponsorOrgId,
  })

  if (isPending || isFetching || isError) {
    return <Skeleton height={32} width={width} />
  }

  const logoField = LOGO_FIELD[variant][theme.palette.mode]

  const url = data?.fields[logoField].fields.file.url
  const selectedAltText = altText || data?.fields[logoField].fields.description

  const sourceSet = !!height
    ? `${url}?h=${height}, ${url}?h=${height * 2} 2x, ${url}?h=${height * 3} 3x`
    : `${url}?w=${width}, ${url}?w=${width * 2} 2x, ${url}?w=${width * 3} 3x`

  return (
    <img
      alt={selectedAltText}
      src={url}
      srcSet={sourceSet}
      style={{ width, objectFit: 'contain', ...logoStyle }}
    />
  )
}
